import CallApi from '../../apiClient'
import { routes } from './routes'

export const getNewClients = async (params) => {
  return CallApi({ ...routes.get_clients, params })
}

export const addNewClients = async (data) => {
  const postData = new FormData()
  Object.keys(data).forEach(key => {
    postData.append(key, data[key])
  })

  return CallApi(routes.add_new_clients, postData, { 'Content-Type': 'multipart/form-data' })
}

export const deleteToken = async (id) => {
  return CallApi({
    ...routes.delete_token,
    url: routes.delete_token.url.replace(':id', id)
  })
}
